import styled from 'styled-components';
import Text from './Text';

const ToggleableText = styled(Text)`
  opacity: 1;
  ${({ isActive }) => (isActive ? `text-decoration: underline` : '')};
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
`;

export default ToggleableText;
